export const AUTH_TOKEN_COOKIE = 'iservice_member_app_token' as const;

export type CookieName = typeof AUTH_TOKEN_COOKIE;
